var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWearecoralLogoGradientWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 448.08 146.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 { fill: url(#linear-gradient); }\n      .cls-2 { fill: #ffffff; }\n      .cls-5 { display: none; }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.85,
    y1: 73.25,
    x2: 122.91,
    y2: 73.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fe7f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c102a7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "wordmark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,73.25c0-9.03,7.32-16.35,16.35-16.35s16.35,7.32,16.35,16.35-7.32,16.35-16.35,16.35S0,82.28,0,73.25ZM10.23,54.95c4.5,0,8.15-3.66,8.15-8.17s-3.65-8.17-8.15-8.17-8.15,3.66-8.15,8.17,3.65,8.17,8.15,8.17ZM10.23,91.48c-4.5,0-8.15,3.66-8.15,8.17s3.65,8.17,8.15,8.17,8.15-3.66,8.15-8.17-3.65-8.17-8.15-8.17ZM38.7,50.8c-4.5,0-8.15,3.66-8.15,8.17s3.65,8.17,8.15,8.17,8.15-3.66,8.15-8.17-3.65-8.17-8.15-8.17ZM38.7,79.28c-4.5,0-8.15,3.66-8.15,8.17s3.65,8.17,8.15,8.17,8.15-3.66,8.15-8.17-3.65-8.17-8.15-8.17ZM99.73,18.3c4.51,0,8.17-3.65,8.17-8.15s-3.66-8.15-8.17-8.15-8.17,3.65-8.17,8.15,3.66,8.15,8.17,8.15ZM46.85,18.3c4.51,0,8.17-3.65,8.17-8.15s-3.66-8.15-8.17-8.15-8.17,3.65-8.17,8.15,3.66,8.15,8.17,8.15ZM87.53,30.47c-4.51,0-8.17,3.65-8.17,8.15s3.66,8.15,8.17,8.15,8.17-3.65,8.17-8.15-3.66-8.15-8.17-8.15ZM59.06,30.47c-4.51,0-8.17,3.65-8.17,8.15s3.66,8.15,8.17,8.15,8.17-3.65,8.17-8.15-3.66-8.15-8.17-8.15ZM99.73,128.13c-4.51,0-8.17,3.65-8.17,8.15s3.66,8.15,8.17,8.15,8.17-3.65,8.17-8.15-3.66-8.15-8.17-8.15ZM46.85,128.13c-4.51,0-8.17,3.65-8.17,8.15s3.66,8.15,8.17,8.15,8.17-3.65,8.17-8.15-3.66-8.15-8.17-8.15ZM87.53,99.65c-4.51,0-8.17,3.65-8.17,8.15s3.66,8.15,8.17,8.15,8.17-3.65,8.17-8.15-3.66-8.15-8.17-8.15ZM59.06,99.65c-4.51,0-8.17,3.65-8.17,8.15s3.66,8.15,8.17,8.15,8.17-3.65,8.17-8.15-3.66-8.15-8.17-8.15ZM73.25,32.7c9.03,0,16.35-7.32,16.35-16.35S82.28,0,73.25,0s-16.35,7.32-16.35,16.35,7.32,16.35,16.35,16.35ZM73.25,113.81c-9.03,0-16.35,7.32-16.35,16.35s7.32,16.35,16.35,16.35,16.35-7.32,16.35-16.35-7.32-16.35-16.35-16.35ZM44.58,44.58c6.38-6.38,6.38-16.74,0-23.12-6.38-6.38-16.74-6.38-23.12,0s-6.38,16.74,0,23.12,16.74,6.38,23.12,0ZM101.93,101.93c-6.38,6.38-6.38,16.74,0,23.12,6.38,6.38,16.74,6.38,23.12,0s6.38-16.74,0-23.12-16.74-6.38-23.12,0ZM101.93,44.58c6.38,6.38,16.74,6.38,23.12,0s6.38-16.74,0-23.12-16.74-6.38-23.12,0c-6.38,6.38-6.38,16.74,0,23.12ZM44.58,101.93c-6.38-6.38-16.74-6.38-23.12,0s-6.38,16.74,0,23.12,16.74,6.38,23.12,0c6.38-6.38,6.38-16.74,0-23.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.13,87.91h-7l-6.1-18.58-6.16,18.58h-7l-9.66-29.15h7.46l5.76,18.3,6.1-18.3h6.95l6.1,18.36,5.82-18.36h7.46l-9.72,29.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.2,81.52c5.71,0,9.77-3.39,9.77-3.39v6.95s-3.78,3.16-10.73,3.16c-9.04,0-15.59-6.67-15.59-14.91s6.38-14.91,14.4-14.91,13.56,6.67,13.56,14.91c0,.79-.06,1.64-.17,2.43h-20.05c.73,3.39,3.39,5.76,8.81,5.76ZM229.32,70.51c-.68-3.16-2.71-5.48-6.27-5.48-3.78,0-5.87,2.32-6.67,5.48h12.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.7,58.76v29.15h-7.46v-3.79c-2.2,2.54-5.25,4.12-8.7,4.12h-.06c-6.89,0-12.31-6.61-12.31-14.91s5.42-14.91,12.31-14.91h.06c3.45,0,6.5,1.58,8.7,4.12v-3.78h7.46ZM260.24,73.33c0-4.12-2.99-7.46-6.72-7.46h-.06c-3.95,0-6.83,3.28-6.83,7.46s2.94,7.46,6.83,7.46h.06c3.73,0,6.72-3.33,6.72-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.24,66.89l-12.31,7.29v13.73h-7.46v-29.15h7.46v7.06c3.33-2.03,12.31-7.4,12.31-7.4v8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.9,81.52c5.71,0,9.77-3.39,9.77-3.39v6.95s-3.79,3.16-10.73,3.16c-9.04,0-15.59-6.67-15.59-14.91s6.38-14.91,14.4-14.91,13.56,6.67,13.56,14.91c0,.79-.06,1.64-.17,2.43h-20.05c.73,3.39,3.39,5.76,8.81,5.76ZM315.02,70.51c-.68-3.16-2.71-5.48-6.27-5.48-3.79,0-5.88,2.32-6.67,5.48h12.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.4,66.89c-1.41-.62-3.16-1.07-5.08-1.07-4.86,0-8.13,2.94-8.13,7.51s3.39,7.46,8.19,7.46c1.98,0,3.95-.51,5.54-1.13,2.26-.79,3.84-1.75,3.84-1.75v7.63s-3.67,2.71-10.45,2.71c-8.47,0-14.57-6.67-14.57-14.91s6.21-14.91,14.69-14.91c5.87,0,10.22,2.82,10.22,2.82v8.3s-1.58-1.58-4.24-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.42,73.33c0-8.25,6.44-14.91,14.46-14.91h.06c8.02,0,14.4,6.72,14.4,14.91s-6.38,14.91-14.4,14.91h-.06c-8.02,0-14.46-6.67-14.46-14.91ZM366.94,80.79c3.9,0,6.95-3.33,6.95-7.46s-3.11-7.46-6.95-7.46h-.06c-3.95,0-7,3.33-7,7.46s3.05,7.46,7,7.46h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.27,66.89l-12.31,7.29v13.73h-7.46v-29.15h7.46v7.06c3.33-2.03,12.31-7.4,12.31-7.4v8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.97,58.76v29.15h-7.46v-3.79c-2.2,2.54-5.25,4.12-8.7,4.12h-.06c-6.89,0-12.31-6.61-12.31-14.91s5.42-14.91,12.31-14.91h.06c3.45,0,6.5,1.58,8.7,4.12v-3.78h7.46ZM427.51,73.33c0-4.12-2.99-7.46-6.72-7.46h-.06c-3.95,0-6.83,3.28-6.83,7.46s2.94,7.46,6.83,7.46h.06c3.73,0,6.72-3.33,6.72-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M448.08,87.91h-7.46v-40.67h7.46v40.67Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 450.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 419.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 387.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 356.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 324.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 293.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 261.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 230.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 198.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 166.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 135.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 103.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2800.96,
    cy: 4158.61,
    r: 72.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 9.78,
    cy: -37.71,
    r: 40.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 9.78,
    cy: -37.71,
    r: 51.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 9.78,
    cy: -37.71,
    r: 63.76
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWearecoralLogoGradientWhite);
export default __webpack_public_path__ + "static/media/wearecoral-logo-gradient-white.188f8031a953da80a4ef4930e014794c.svg";
export { ForwardRef as ReactComponent };